export interface AppConfigContextData {
  VITE_YMS_API_URL: string;
  VITE_YMS_WEBSITE: string;
  VITE_DD_RUM_ENV: string;
  VITE_DD_CLIENT_TOKEN_ID: string;
  VITE_DD_SERVICE: string;
  VITE_DD_APPLICATION_ID: string;
  VITE_YMS_NOTIFICATION: string;
  VITE_AZURE_TENANT_NAME: string;
  VITE_AZURE_USER_FLOW: string;
  VITE_YMS_API_MOCK: string;
  VITE_AZURE_CLIENT_ID: string;
  VITE_YMS_APIM_URL?: string;
  VITE_YMS_APIM_SUBS_KEY: string;
  VITE_VEHICLE_RELEASE_ALLOWED_PROCESS_ID: string;
  VITE_DEFAULT_LANGUAGE: string;
  VITE_KC_CLIENT_ID: string;
  VITE_KC_ENVIRONMENT: string;
  VITE_NEW_NPS_API_ENDPOINT: string;
  VITE_YMS_REGION?: string;
}

export const readConfigFile = async (): Promise<AppConfigContextData> => {
  const base_url = window.location.origin;
  const response = await fetch(`${base_url}/configuration/configuration.json`);

  if (!response.ok) {
    throw new Error(`Error loading configuration file: ${response.status} ${response.statusText}`);
  }

  const contentType = response.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    throw new Error(`Invalid response: expected JSON but received ${contentType || "unknown"}`);
  }

  const configs: AppConfigContextData = await response.json();

  return configs;
};
